import DOMPurify from 'dompurify';

interface RichTextDisplayProps {
  content: string | null | undefined;
  className?: string;
}

/**
 * Safely renders HTML content that has been sanitized with DOMPurify.
 * Used for displaying rich text content from the database.
 */
export function RichTextDisplay({ content, className }: RichTextDisplayProps) {
  if (!content) {
    return null;
  }

  // Sanitize the HTML content to prevent XSS attacks
  const sanitizedContent = DOMPurify.sanitize(content);

  return (
    <div
      className={`prose prose-sm max-w-none text-foreground ${className || ''}`}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
}
